import { Container } from 'inversify';
import 'reflect-metadata';

import * as DesygnerTheme from '@desygner/ui-common-theme-desygner';
import * as FluerTheme from '@desygner/ui-common-theme-fluer';
import { type IApiGateway, container as apiGatewayContainer } from '@desygner/ui-core-api-gateway';
import { type IAureliaLoader, aureliaLoaderModule } from '@desygner/ui-core-aurelia-loader';
import { monitoringModule } from '@desygner/ui-core-monitoring';
import { type IProjectService } from '@desygner/ui-data-access-projects';
import { projectsModule } from '@desygner/ui-features-projects';
import { restrictionsModule } from '@desygner/ui-features-restrictions';

import { serviceContainer } from './core/services-container';
import { IPostMessageManager, PostMessageManager } from './core/viewer/postmessage-manager';
import { ViewerLoader } from './core/viewer/viewer-loader';
import { TYPES } from './inversify.types';
import { storeContainer } from './store';
import type { IConfigStoreInjector, IViewerStoreInjector } from './store';

interface ITheme {
  Light: typeof DesygnerTheme.Theme | typeof FluerTheme.Theme;
  Dark: typeof DesygnerTheme.DarkTheme | typeof FluerTheme.DarkTheme;
}

const appContainer = new Container({
  skipBaseClassChecks: true,
});

appContainer.load(apiGatewayContainer);
appContainer.load(storeContainer);
appContainer.load(serviceContainer);
appContainer
  .bind<IPostMessageManager>(TYPES.Viewer.PostMessageManager)
  .to(PostMessageManager)
  .inSingletonScope();

appContainer.bind(TYPES.Viewer.ViewerLoader).to(ViewerLoader).inSingletonScope();

appContainer.load(projectsModule);
appContainer.load(restrictionsModule);
appContainer.load(monitoringModule);

/**
 * Modules for Fluer
 */
if (process.env.BRAND === 'fluer') {
  appContainer.bind(TYPES.Theme).toConstantValue({
    Light: FluerTheme.Theme,
    Dark: FluerTheme.DarkTheme,
  });
} else {
  /**
   * Modules for Desygner
   */
  appContainer.load(aureliaLoaderModule);
  appContainer.bind(TYPES.Theme).toConstantValue({
    Light: DesygnerTheme.Theme,
    Dark: DesygnerTheme.DarkTheme,
  });
}

export {
  appContainer,
  IAureliaLoader,
  IApiGateway,
  IProjectService,
  ITheme,
  TYPES,
  IConfigStoreInjector,
  IViewerStoreInjector,
};
